import React, { useState } from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  className?: string;
  showText?: boolean;
  variant?: 'default' | 'light' | 'dark';
}

/**
 * Logo component that can be used across the application
 * Supports different variants for different backgrounds
 * @param variant - 'default' | 'light' | 'dark' - determines which logo to show
 * @param showText - whether to show the text next to the logo
 * @param className - additional classes to apply
 */
const Logo: React.FC<LogoProps> = ({ 
  className = '', 
  showText = true,
  variant = 'default'
}) => {
  const [imageError, setImageError] = useState(false);
  
  const getLogoPath = () => {
    switch (variant) {
      case 'light':
        return '/images/krystal_logo_light.png';
      case 'dark':
        return '/images/krystal_logo_dark.png';
      default:
        return '/images/krystal_logo.png';
    }
  };

  const getTextColor = () => {
    switch (variant) {
      case 'light':
        return 'text-white';
      case 'dark':
        return 'text-blue-900';
      default:
        return 'text-primary';
    }
  };
  
  return (
    <Link 
      to="/" 
      className={`flex items-center space-x-3 py-2 ${className}`}
      aria-label="Krystal Sports Management"
    >
      {!imageError ? (
        <img 
          src={getLogoPath()}
          alt="Krystal Logo" 
          className="h-16 w-auto"
          onError={() => setImageError(true)}
          loading="lazy"
        />
      ) : (
        <span className={`text-4xl font-bold ${getTextColor()}`}>K</span>
      )}
      {showText && (
        <span className={`text-3xl font-bold ${getTextColor()} hidden sm:inline-block`}>
          Krystal
        </span>
      )}
    </Link>
  );
};

export default Logo; 